var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import TopStories from "dashboard/components/TopStories";
import { getStoriesStream, setStoryStream } from "actions/storiesStream";
import { setSectionWithTag, setSection } from "actions/navigation";
import { FRONTEND_ROOT } from "config/constants";

var TagStream = function (_React$Component) {
  _inherits(TagStream, _React$Component);

  function TagStream(props) {
    _classCallCheck(this, TagStream);

    var _this = _possibleConstructorReturn(this, (TagStream.__proto__ || Object.getPrototypeOf(TagStream)).call(this, props));

    _this.loadNextPage = _this._loadNextPage.bind(_this);
    return _this;
  }

  _createClass(TagStream, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadStream(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setSection(null);
      if (this.props.stream.results && this.props.stream.results.length) {
        this.props.setStoryStream([]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.match.params.tag !== nextProps.match.params.tag) {
        this.loadStream(nextProps);
      }
    }
  }, {
    key: "loadStream",
    value: function loadStream(props) {
      this.props.setSectionWithTag(props.match.params.tag);
      this.props.getStoriesStream({ stream: props.match.params.tag });
    }
  }, {
    key: "_loadNextPage",
    value: function _loadNextPage(page) {
      return this.props.getStoriesStream({
        page: page,
        stream: this.props.match.params.tag
      }, true);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        null,
        this.props.section && React.createElement(
          Helmet,
          null,
          React.createElement(
            "title",
            null,
            this.props.section.name,
            " - Axios"
          ),
          React.createElement("meta", { property: "og:url", content: FRONTEND_ROOT + "/tag/" + this.props.section.slug + "/" }),
          React.createElement("meta", { property: "og:title", content: this.props.section.name + " on Axios" })
        ),
        React.createElement(TopStories, {
          isTagPage: true,
          loadNextPage: this.loadNextPage,
          onlyShowSectionForA11y: true
        })
      );
    }
  }]);

  return TagStream;
}(React.Component);

TagStream.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      tag: PropTypes.string.isRequired
    })
  }),
  section: PropTypes.object,
  setSectionWithTag: PropTypes.func.isRequired,
  getStoriesStream: PropTypes.func.isRequired,
  setSection: PropTypes.func,
  stream: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired
  })
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    section: state.navigation.data.section,
    stream: state.storiesStream
  };
};

var mapDispatchToProps = {
  setSectionWithTag: setSectionWithTag,
  getStoriesStream: getStoriesStream,
  setSection: setSection,
  setStoryStream: setStoryStream
};

export default connect(mapStateToProps, mapDispatchToProps)(TagStream);


// WEBPACK FOOTER //
// ./src/dashboard/containers/TagStream/TagStream.js